const projectData = [];
export const GetProjectDataReducer = (state = projectData, action) => {
  switch (action.type) {
    case "get_projectData":
      return {
        projectData: action.payload,
      };
    default:
      return state;
  }
};
const initialState = {
  assignedProjects: [],
};

export const GetAssignedProjectsReducer = (state = initialState, action) => {
  switch (action.type) {
    // Handling the successful action of assigned projects
    case "get_assignedProjects":
      return {
        ...state,
        assignedProjects: action.payload, // Set assigned projects from the payload
      };

    default:
      return state;
  }
};
